import React from "react";
import styles from "./AllTask.module.scss";
import { Button, Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import Task from "../../Page/Task/Task";
import Filter from "../Filter/Filter";
import filterIcon from "../../Components/icons/filter.svg"
import {CSSTransition} from "react-transition-group";
import Pause from "./Pause";
import {withRouter} from "react-router-dom";
class AllTask extends React.Component {
    state = {
        show: false,
        filter:false
    }
    toggleFilter = ()=>{
        this.setState({
            filter:!this.state.filter
        })
    }
    toggleFilterFalse = ()=>{
        this.setState({
            filter:false,
            show:true
        })
    }
    backbutton = ()=>{
        this.setState({
            show:false
        })
    }
    render() {  
        const toRender = (
            <div  className="p-3 h-100 position-relative">
                <div>
                    <Row>
                        <Col md={7}><p style={{
                            fontSize: "23px",
                            fontWeight: "500"
                        }}>Tasks</p></Col>
                        <Col md={5} style={{
                            padding: "0 20px 0 0"
                        }}><Button onClick={this.toggleFilter} className={styles.task_filter_btn} variant="outline-secondary" style={{ 
                            backgroundColor: "white", borderRadius: "25px", color: "black", borderColor: "#EBEDF0" 
                        }}><img width="25px" src={filterIcon} alt="filter"></img><small style={{
                            fontSize: "100%",
                            paddingLeft: "5px",
                            fontWeight: "500",
                            top: "1px",
                            position: "relative"
                        }}>Filter</small></Button></Col>
                    </Row>
                </div>
                <div style={{
                    overflowX: "scroll",
                    scrollbarWidth: "none",
                    marginTop:"34px",
                    color: "#ced2da"
                }} className="d-flex  justify-content-between ">
                    <p style={{
                        cursor: "pointer",
                        color: "#3e7aff",
                        borderBottom: "3px solid #99b7fb",
                        fontSize:"16px"

                    }} className="">All</p>
                    <p style={{
                        cursor: "pointer",
                        fontSize:"16px",
                        marginLeft:"29px"
                    }}>Active</p>
                    <p style={{
                        cursor: "pointer",
                        fontSize:"16px",
                        marginLeft:"29px"
                    }}>Done</p>
                    <p style={{
                        cursor: "pointer",
                        fontSize:"16px",
                        marginLeft:"29px"
                    }} >Pause</p>
                    <p style={{
                        cursor: "pointer",
                        fontSize:"16px",
                        marginLeft:"29px"
                    }} c>Schedule</p>
                </div>
                <div style={{
                    height:"70%"
                }} className="mt-4 d-flex flex-column justify-content-between">
                    <div style={{ overflowY: "scroll", scrollbarWidth:"thin",overflowX: "hidden", height: "100%", marginRight: "-15px" }} id="p-bar">

                        {this.props.tasks.map((e,idx) => {
                            return (
                                [
                            <Pause index={idx} history={this.props.history} tracktername={e.tracktername} status={e.status} completiontime={e.completiontime} />
                                ]
                                
                            )
                        })}


                    </div>



                </div>
                <button
                    onClick={() => {
                        this.setState({
                            show:true
                        })
                    }
                    }
                    style={{
                        marginTop: "0.5rem",
                        position:"absolute",
                        bottom:"5px",
                        left:1.5,
                    }} className="blue_button">
                    Create New Task
             </button>

            </div>
        )
        return (
           <React.Fragment>      
        {this.state.filter? <Filter toggleFilterFalse={this.toggleFilterFalse} toggleFilter={this.toggleFilter}></Filter>:null}
        {(!this.state.show && !this.state.filter)?toRender:null}
        {!this.state.filter? <CSSTransition
        in={this.state.show} timeout={100} classNames="my-node">
            <Task resetInfo={this.props.resetInfo} implementName={this.props.implementName} implementSrc={this.props.implementSrc}  toggleImplement={this.props.toggleImplement} name={this.props.name} color={this.props.color} toggleTracktor={this.props.toggleTracktor} focusZone={this.props.focusZone} back_button={this.backbutton}></Task>
        </CSSTransition>:null}
           </React.Fragment>
          

        )
    }
}

const mapStateToProps = state => {
    return {
        tasks: state.tasks
    }
}

export default connect(mapStateToProps, null)(withRouter(AllTask));



